export const INPUT_CONTAINER = "flex flex-col mx-auto";
export const CHECK_BOX_CONTAINER = "flex flex-row items-justify";
export const CHECK_BOX_INPUT = " peer opacity-0 absolute h-6 w-6 ";
export const CUSTOM_BOX_CONTAINER =
    "border-1 peer-checked:!bg-Pink_Rose border rounded-sm border-BORDER_GRAY  peer-checked:!border-Pink_Rose w-6 h-6 flex flex-shrink-0 justify-center items-center focus-within:border-Pink_Rose";
export const LABEL_CLASS =
    "ml-[10px] md:ml-[15px] !capitalize font-normal text-sm !text-Primary_Default font-Poppins";
